import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateBanner, UpdateBannerParams} from '../api';
import {QUERY__BANNERS} from '../queryKeys';

export const useUpdateBanner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateBannerParams) => updateBanner(params),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({queryKey: [QUERY__BANNERS]});
      void queryClient.invalidateQueries({
        queryKey: [QUERY__BANNERS, variables.id],
      });
    },
  });
};
